// extracted by mini-css-extract-plugin
export default {"packages":"Packages_packages__ATwJf"};